export default __webpack_public_path__ + "static/media/message_bottom.9659fa72.png";